import { Component, Input } from '@angular/core';

import { Asset } from '@app/modules/location-client/location-api.models';
import { AssetIoService } from '../../asset-io.service';

@Component({
  selector: 'app-asset-io-details',
  templateUrl: './asset-io-details.component.html',
  styleUrls: ['./asset-io-details.component.scss']
})
export class AssetIoDetailsComponent {
  @Input() asset: Asset;

  constructor(public assetIoService: AssetIoService) {}
}
